export const SET_IS_CHAT_ENABLED = 'SET_IS_CHAT_ENABLED';
export const SET_CS_ORDERS = 'SET_CS_ORDERS';

export const CS_SECTIONS_IDS = {
    faq: 'cs-faq',
    contact: 'cs-contact'
};
